import { isDomainEntity } from '@backstage/catalog-model';
import {
  isChapterEntity,
  isDataProductEntity,
  isDemandEntity,
  isOrganisationDsoEntity,
  isOrganisationEntity,
  isPartnerSystemEntity,
  isProductEntity,
  isSolutionEntity,
  isSolutionScalingEntity,
  isSquadEntity,
} from '@ipen-portal/ipen-entity-model';

import { KeyRole } from './KeyRole';

/**
 * A list of roles known by iPEN
 */
const keyRoles = [
  new KeyRole(isOrganisationDsoEntity, 'ipenSpoc', {
    label: 'iPEN SPOC',
  }),
  new KeyRole(isOrganisationDsoEntity, 'dataSpoc', {
    label: 'Data SPOC',
  }),
  new KeyRole(isOrganisationDsoEntity, 'dataIntegrationLead'),
  new KeyRole(isOrganisationDsoEntity, 'digitalLead'),
  new KeyRole(isOrganisationDsoEntity, 'deliveryManager'),
  new KeyRole(isOrganisationDsoEntity, 'gridOnFTO', {
    label: 'GridON! FTO',
  }),
  new KeyRole(isOrganisationDsoEntity, 'parent', {
    kind: 'Group',
    label: 'Parent Company',
  }),

  new KeyRole(isOrganisationEntity, 'digitalLead'),
  new KeyRole(isOrganisationEntity, 'parent', {
    kind: 'Group',
    label: 'Parent Company',
  }),

  new KeyRole(isPartnerSystemEntity, 'businessOwner', {
    kind: 'Group',
    label: 'Leading Organisation',
  }),
  new KeyRole(isPartnerSystemEntity, 'owner', {
    kind: 'Group',
    label: 'Leading Squad',
    skipRelationProcessing: true,
  }),
  new KeyRole(isPartnerSystemEntity, 'productOwner'),
  new KeyRole(isPartnerSystemEntity, 'technicalProductOwner'),

  new KeyRole(isProductEntity, 'owner', {
    kind: 'Group',
    label: 'Leading Squad',
    skipRelationProcessing: true,
  }),
  new KeyRole(isProductEntity, 'businessOwner', {
    kind: 'Group',
    label: 'Leading Organisation',
  }),
  new KeyRole(isProductEntity, 'productOwner'),
  new KeyRole(isProductEntity, 'technicalProductOwner'),
  new KeyRole(isDataProductEntity, 'owner', {
    kind: 'Group',
    label: 'Leading Squad',
    skipRelationProcessing: true,
  }),

  new KeyRole(isSolutionEntity, 'businessOwner', {
    kind: 'Group',
    label: 'Leading Organisation',
  }),
  // TODO Philipp: Eigentlich war mal geplant die Solution Teams als Owner zu pflegen.
  //   Diese haben wir aber noch nicht in das Portal aufgenommen.
  //   Daher war immer die DSO unsere Zwischenlösung.
  //   Da aber die DSO kein Squad ist, wird diese Key-Role vorerst entfernt.
  // new KeyRole(isSolutionEntity, 'owner', {
  //   kind: 'Group',
  //   skipRelationProcessing: true,
  //   label: 'Leading Squad',
  // }),
  new KeyRole(isSolutionEntity, 'solutionOwner'),
  new KeyRole(isSolutionEntity, 'solutionDevelopmentLead'),
  new KeyRole(isSolutionEntity, 'deliveryManager'),

  new KeyRole(isSolutionScalingEntity, 'rolloutManager'),

  new KeyRole(isSquadEntity, 'productOwner'),
  new KeyRole(isSquadEntity, 'technicalProductOwner'),
  new KeyRole(isSquadEntity, 'scrumMaster'),
  new KeyRole(isSquadEntity, 'parent', {
    kind: 'Group',
    label: 'Tribe',
  }),

  new KeyRole(isChapterEntity, 'chapterLead'),
  new KeyRole(isChapterEntity, 'parent', {
    kind: 'Group',
    label: 'Tribe',
  }),

  new KeyRole(isDomainEntity, 'owner', {
    label: 'Focus Topic Owner',
  }),

  new KeyRole(isDemandEntity, 'requester', {
    skipRelationProcessing: true,
  }),
  new KeyRole(isDemandEntity, 'assignee', {
    skipRelationProcessing: true,
  }),
];

/**
 * All defined field names
 */
type KeyRolesFields =
  typeof keyRoles extends (infer KR)[]
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ? KR extends KeyRole<any, infer FIELD>
      ? FIELD
      : never[]
    : never;

export { keyRoles, type KeyRolesFields };
